export default function BusinessInfoSection({ form, patch }) {
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.02] p-4 space-y-3">
      <label
        className="flex items-center justify-between gap-3 cursor-pointer"
        data-testid="branding-show-business-info-toggle"
      >
        <span>
          <div className="font-display font-semibold text-[14px] mb-0.5">
            Show GST & address on quotations
          </div>
          <div className="text-[11px] text-white/40">
            When enabled, these appear right after the firm name on the
            public quotation page, the PDF header and the WhatsApp message.
          </div>
        </span>
        <input
          type="checkbox"
          className="w-5 h-5 accent-[color:var(--primary)] shrink-0"
          checked={form.show_business_info}
          onChange={(e) => patch("show_business_info", e.target.checked)}
          data-testid="branding-show-business-info-checkbox"
        />
      </label>

      <div>
        <label className="label-luxe">GST / Tax ID (optional)</label>
        <input
          className="input-luxe uppercase tracking-wider"
          value={form.gst_number}
          onChange={(e) => patch("gst_number", e.target.value.toUpperCase())}
          placeholder="e.g. 29ABCDE1234F1Z5"
          maxLength={30}
          data-testid="branding-gst-input"
        />
      </div>

      <div>
        <label className="label-luxe">Registered address (optional)</label>
        <textarea
          className="input-luxe !h-24 !py-3 leading-snug resize-none"
          value={form.address}
          onChange={(e) => patch("address", e.target.value)}
          placeholder="12 MG Road, Bangalore 560001"
          maxLength={240}
          rows={3}
          data-testid="branding-address-input"
        />
        <div className="text-[10px] text-white/30 text-right mt-1">
          {form.address.length}/240
        </div>
      </div>
    </div>
  );
}
